import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'smart-config-weather',
  templateUrl: './config-weather.component.html',
  styleUrls: ['./config-weather.component.css']
})
export class ConfigWeatherComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
